// Who runs ConfirmPay, as the legal pages and emails say it. Import-free so the server, the
// pages and the tests all read the one value.

export const OPERATOR_NAME = "Hafizuddin";
/** The date the Privacy Policy and Terms of Service last changed. */
export const LEGAL_UPDATED = "13 October 2026";

// The privacy email is stored reversed and only put together when needed, so the address never
// sits in the page source or the built files. The pages reveal it on a click, as madebyhafiz.com does.
const REVERSED = { user: "ycavirp", domain: "knil.yapmrifnoc" };
const reverse = (s: string) => s.split("").reverse().join("");

/** The privacy email address. */
export function privacyEmail(): string {
  return `${reverse(REVERSED.user)}@${reverse(REVERSED.domain)}`;
}

/** For the server, which writes the address into emails it sends. */
export const PRIVACY_EMAIL = privacyEmail();
